<mf-page title="Editar monto asignado">
  <mf-field-numeric
    [(ngModel)]="collectOrder.amount"
    (ngModelChange)="updateAmount($event)">
  </mf-field-numeric>
  <mf-button
    text="Guardar"
    (click)="save()"></mf-button>
</mf-page>
